import AppConfirmDialog from '../../../../../../components/ui/AppConfirmDialog';
import React, {useState} from "react";
import {useHistory} from 'react-router-dom';
import {Button} from 'primereact/button';
import {BlockUI} from 'primereact/blockui';
import apiClient from "../../../../../../services/api-client";
import AnimatedSuccessGIF from '../../../../../../assets/images/check-green.gif';
import {Dialog} from 'primereact/dialog';
import {useFormik} from 'formik';
import StorageHelper from '../../../../../../utils/storage-helper';
import TermsContent from '../../../../../../components/ui/TermsContent';


const ConfirmationForm = ({ moveToNextView, moveToPreviousView, userPolicyInput, setuserPolicyInput, titles, toast }) => {
  const [visible, setVisible] = useState(false);
  const history = useHistory()
  const [loading, setloading] = useState(false);
  
  const [canSubmit, setCanSubmit] = useState(false)

  const [visibleTC, setvisibleTC] = useState(false);

  const footerContent = (
    <div>
      <Button label="No" icon="pi pi-times" onClick={() => {
        formik.setFieldValue('item', false);
        setCanSubmit(false)
        setvisibleTC(false)
      }} className="btn btn-ghost p-button-text" />
      <Button className="btn btn-primary text-white" label="Yes" icon="pi pi-check" onClick={() => {
        formik.setFieldValue('item', true);
        setCanSubmit(true)
        setvisibleTC(false)
      }
      } autoFocus />
    </div>
  );

  // ACCEPT TERMS AND CONDITIONS

  const formik = useFormik({
    initialValues: {
      item: null
    },
    validate: (data) => {
      let errors = {};

      if (!data.item || data.item === 'null') {
        errors.item = 'Value is required.';
      }

      return errors;
    },
    onSubmit: (data) => {
      data.item && setCanSubmit(true);
      formik.resetForm();
    }
  });

  const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> : <small className="p-error">&nbsp;</small>;
  };

  // END OF TERMS AND CONDITIONS

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   onNextStep({ termsAgreed });
  // };

  // const handleTermsAgreementChange = () => {
  //   setTermsAgreed(true);
  // };


  const moveToNext = (e) => {
    
    // e.preventDefault();

    const payload = {
      "operation": "createPolicyApplicationStage3",
      "requestBody": {
        "planId": userPolicyInput.selectedPlanName,
        "planName": userPolicyInput.selectedPlanID,
        "productId": userPolicyInput.selectedProductId,
        "productName": userPolicyInput.selectedProductName,
        "applicationTotalStages": 3,
        "currentStages": 3,
        "applicationType": userPolicyInput.selectedPlanType,
        "mainMember": userPolicyInput.mainMember,
        "memberSpouse": userPolicyInput.memberSpouse,
        "memberChild": userPolicyInput.memberChild,
        "memberExtended": userPolicyInput.memberExtended,
        "memberBeneficiary": userPolicyInput.memberBeneficiary,
        "bankDetail": userPolicyInput.bankDetail
      }
    } 
    setuserPolicyInput({ ...userPolicyInput });
    submitStage4toServer(payload);
  };

  const showToastMessage = (title, message, messageType) => {
    toast.current.show({ severity: messageType, summary: title, detail: message, life: 15000 });
  }

  const submitStage4toServer = async (payload) => {
    setloading(true); 
    await apiClient.post('policy/apply/3', payload,{
      headers: {
        Authorization: 'Bearer ' + (StorageHelper.get('token'))
      }
    }).then((response) => {

      if (response.data.status === "SUCCESS") {
        setloading(false);
        //console.log(response.data.responseBody)
        setVisible(true)
        showToastMessage("Progress Saved", userPolicyInput.mainMemberName + " your progress has been saved", "success");

      }
      else {
        setloading(false);
        showToastMessage("Failed to save your progress", response.data.message, "warn");
      }
    }).catch((e) => {
      setloading(false);  
    })


  }
  
  const openConfirmDialog = () => {
    document.getElementById('confirm_app_modal').showModal();
  };

  const handleConfirmed = () => {
    moveToNext();
  };

  return (
    <div className="w-full max-w-5xl mx-auto mb-12">
      
      <AppConfirmDialog
        id="confirm_app_modal"
        title="Confirm your application details?"
        message="Are you sure all the provided details are correct? Once submitted, the application will be processed."
        onConfirm={handleConfirmed}
        confirmText="Confirm"
        confirmStyle="btn-success text-white"
        icon="pi-file-edit text-primary"
      />

      <BlockUI blocked={loading}>
        <div className="card bg-base-100 shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-base-200/60 overflow-hidden rounded-2xl">
            <div className="bg-base-200/50 px-8 py-6 border-b border-base-200">
                <h3 className="text-2xl font-bold text-base-content mb-1">Confirm your policy details</h3>
                <p className="text-base-content/70 text-sm">Review your application before submitting.</p>
            </div>
            
            <div className="p-8">
              
              <div className="join join-vertical w-full shadow-sm">
                
                {/* Plan & Policy Benefits */}
                <div className="collapse collapse-arrow join-item border border-base-300 bg-white">
                  <input type="radio" name="confirmation-accordion" defaultChecked /> 
                  <div className="collapse-title text-lg font-semibold flex items-center gap-2">
                    <i className="pi pi-shield text-primary"></i> Plan & Policy Benefits
                  </div>
                  <div className="collapse-content">
                    <div className="grid grid-cols-1 gap-6 pt-4 border-t border-base-200">
                        <div className="bg-base-50 p-4 rounded-xl border border-base-200">
                            <h4 className="text-sm text-base-content/60 font-semibold uppercase mb-2">Selected Plan/Product</h4>
                            <p className="font-bold text-lg text-primary">{userPolicyInput.selectedProductName}</p>
                        </div>
                        <div className="bg-base-50 p-4 rounded-xl border border-base-200">
                            <h4 className="text-sm text-base-content/60 font-semibold uppercase mb-2">Product Benefits</h4>
                            <p className="font-medium">{userPolicyInput.selectedProduct.BenefitsText || "No benefits listed."}</p>
                        </div>
                    </div>
                  </div>
                </div>

                {/* Principal Member Details */}
                <div className="collapse collapse-arrow join-item border border-base-300 bg-white">
                  <input type="radio" name="confirmation-accordion" /> 
                  <div className="collapse-title text-lg font-semibold flex items-center gap-2">
                    <i className="pi pi-user text-primary"></i> Principal Member Details
                  </div>
                  <div className="collapse-content">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-base-200">
                        <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Title</span><span className="font-semibold">{userPolicyInput.mainMember.Title}</span></div>
                        <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">First Name</span><span className="font-semibold">{userPolicyInput.mainMember.First_Name}</span></div>
                        <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Last Name</span><span className="font-semibold">{userPolicyInput.mainMember.Surname}</span></div>
                        <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">ID Number</span><span className="font-semibold">{userPolicyInput.mainMember.ID_Num}</span></div>
                        <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Gender</span><span className="font-semibold">{userPolicyInput.mainMember.Gender}</span></div>
                        <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Date of Birth</span><span className="font-semibold">{userPolicyInput.mainMember.Date_Of_Birth}</span></div>
                        <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Marital Status</span><span className="font-semibold">{userPolicyInput.mainMember.Marital_Status}</span></div>
                        <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Cell Number</span><span className="font-semibold">{userPolicyInput.mainMember.Cell_Number}</span></div>
                    </div>
                  </div>
                </div>

                {/* Beneficiary Details */}
                <div className="collapse collapse-arrow join-item border border-base-300 bg-white">
                  <input type="radio" name="confirmation-accordion" /> 
                  <div className="collapse-title text-lg font-semibold flex items-center gap-2">
                    <i className="pi pi-users text-primary"></i> Beneficiary Details
                  </div>
                  <div className="collapse-content">
                    <div className="flex flex-col gap-6 pt-4 border-t border-base-200">
                        
                        {/* Spouse */}
                        {userPolicyInput.memberSpouse && Object.keys(userPolicyInput.memberSpouse).length > 0 && (
                            <div className="bg-base-50 p-4 rounded-xl border border-base-200">
                                <h4 className="font-semibold mb-4 text-primary border-b border-base-200 pb-2">Spouse Beneficiary</h4>
                                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                    <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Name</span><span className="font-semibold">{userPolicyInput.memberSpouse.Name} {userPolicyInput.memberSpouse.Surname}</span></div>
                                    <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">ID Number</span><span className="font-semibold">{userPolicyInput.memberSpouse.ID_Num}</span></div>
                                    <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Phone Number</span><span className="font-semibold">{userPolicyInput.memberSpouse.Telephone}</span></div>
                                </div>
                            </div>
                        )}

                        {/* Children */}
                        {userPolicyInput.memberChild && userPolicyInput.memberChild.length > 0 && (
                            <div className="bg-base-50 p-4 rounded-xl border border-base-200">
                                <h4 className="font-semibold mb-4 text-primary border-b border-base-200 pb-2">Children Beneficiaries</h4>
                                <div className="flex flex-col gap-4">
                                    {userPolicyInput.memberChild.map((child) => (
                                        <div key={child.IdNumber} className="grid grid-cols-2 md:grid-cols-3 gap-4 pb-3 border-b border-base-200/50 last:border-0 last:pb-0">
                                            <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Name</span><span className="font-semibold">{child.FirstName} {child.LastName}</span></div>
                                            <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">ID Number</span><span className="font-semibold">{child.IdNumber}</span></div>
                                            <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Gender</span><span className="font-semibold">{child.Gender}</span></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Extended */}
                        {userPolicyInput.memberExtended && userPolicyInput.memberExtended.length > 0 && (
                            <div className="bg-base-50 p-4 rounded-xl border border-base-200">
                                <h4 className="font-semibold mb-4 text-primary border-b border-base-200 pb-2">Extended Family</h4>
                                <div className="flex flex-col gap-4">
                                    {userPolicyInput.memberExtended.map((ext) => (
                                        <div key={ext.IdNumber} className="grid grid-cols-2 md:grid-cols-4 gap-4 pb-3 border-b border-base-200/50 last:border-0 last:pb-0">
                                            <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Name</span><span className="font-semibold">{ext.name} {ext.Surname}</span></div>
                                            <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Relationship</span><span className="font-semibold">{ext.relationship}</span></div>
                                            <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">ID Number</span><span className="font-semibold">{ext.idNumber}</span></div>
                                            <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Gender</span><span className="font-semibold">{ext.gender}</span></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        
                        {/* Empty State */}
                        {(!userPolicyInput.memberSpouse || Object.keys(userPolicyInput.memberSpouse).length === 0) &&
                         (!userPolicyInput.memberChild || userPolicyInput.memberChild.length === 0) &&
                         (!userPolicyInput.memberExtended || userPolicyInput.memberExtended.length === 0) && (
                            <div className="text-center py-6 text-base-content/50 italic">No beneficiaries added.</div>
                        )}

                    </div>
                  </div>
                </div>

                {/* Banking Details */}
                {userPolicyInput.bankDetail && userPolicyInput.bankDetail.length > 0 && (
                <div className="collapse collapse-arrow join-item border border-base-300 bg-white">
                  <input type="radio" name="confirmation-accordion" /> 
                  <div className="collapse-title text-lg font-semibold flex items-center gap-2">
                    <i className="pi pi-building text-primary"></i> Banking Details
                  </div>
                  <div className="collapse-content">
                    <div className="flex flex-col gap-4 pt-4 border-t border-base-200">
                        {userPolicyInput.bankDetail.map((bank) => (
                            <div key={bank.Account_Number} className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-base-50 p-4 rounded-xl border border-base-200">
                                <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Bank Name</span><span className="font-semibold">{bank.BankName}</span></div>
                                <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Account Name</span><span className="font-semibold">{bank.Account_Name}</span></div>
                                <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Account Number</span><span className="font-semibold">{bank.Account_Number}</span></div>
                                <div className="flex flex-col"><span className="text-xs text-base-content/50 uppercase font-bold">Account Type</span><span className="font-semibold">{bank.Type_of_Account}</span></div>
                            </div>
                        ))}
                    </div>
                  </div>
                </div>
                )}

              </div>

              {/* Terms and Conditions */}
              <div className="mt-8 pt-6 border-t border-base-200/50 flex flex-col items-center">
                <label className="cursor-pointer label justify-center gap-3">
                  <input 
                    type="checkbox" 
                    className={`checkbox checkbox-primary ${formik.errors.item ? 'checkbox-error' : ''}`}
                    checked={canSubmit}
                    onChange={(e) => {
                        formik.setFieldValue('item', e.target.checked);
                        setCanSubmit(e.target.checked);
                    }} 
                  />
                  <button type="button" className="label-text font-semibold hover:text-primary transition-colors select-none text-left" onClick={(e) => { e.preventDefault(); setvisibleTC(true); }}>
                    * I've read and accept the terms & conditions. Click here to read Terms and conditions
                  </button>
                </label>
                {getFormErrorMessage('item')}
              </div>
              
              <div className="card-actions justify-center mt-6">
                <button 
                  type="button"
                  onClick={openConfirmDialog} 
                  disabled={!canSubmit}
                  className="btn btn-primary rounded-full px-12 shadow-md hover:shadow-lg transition-all font-bold tracking-wide text-white min-w-[200px]"
                >
                  Submit Application <i className="pi pi-arrow-right ml-2 text-sm"></i>
                </button>
              </div>

            </div>
          </div>
          
          <Dialog header="" visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)} showHeader={false} className="overflow-hidden rounded-2xl">
            <div className="flex flex-col items-center justify-center p-8 bg-white">
              <img width="120px" src={AnimatedSuccessGIF} alt="Success" className="mb-6" />
              <h3 className="text-2xl font-bold text-base-content mb-2 text-center">Policy Application Submitted</h3>
              <p className="text-base-content/70 text-center mb-8">You have successfully submitted your policy application.</p>
              
              <button 
                onClick={() => {
                  setVisible(false);
                  history.push("/");
                }}
                className="btn btn-success text-white rounded-full px-12 font-bold shadow-md hover:shadow-lg"
              >
                <i className="pi pi-check-circle mr-2"></i> Done
              </button>
            </div>
          </Dialog>

          <Dialog header="Read Terms And Conditions" visible={visibleTC} style={{ width: '50vw' }} onHide={() => setvisibleTC(false)} footer={footerContent}>
              <TermsContent className="p-4 bg-base-50 rounded-xl" text={userPolicyInput.selectedSubGroupPlan.termAndConditions} />
          </Dialog>

        </BlockUI>
    </div>
  );
};

export default ConfirmationForm;